import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useAuth } from '../../../firebase/AuthProvider';
import { getUpcomingMeetings, formatMeetingTime, getUpcomingMeetingsByDate } from '../../../services/userServices/UserInfoService';
import joinvideoicon from "../../../assets/images/joinvideoicon.svg";
import { UpcommingMeetingDto } from '../../../interfaces/identity/calendar/Events';
import RescheduleMeetingModal from './Modals/RescheduleMeetingModal';
import { selectedUserForTask$ } from '../../../services/Subjects/userSubject';
import { TeamUser } from '../../../interfaces/team/TeamUser';
import { Subscription } from 'rxjs';
import { GetExistingOrCretateMeetingAsync } from '../../../services/videoService/VideoService';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../loader/Loader';
import { LobbyState } from '../../../interfaces/videocallDtos/videoCall';
import { selectedDate$ } from '../../../services/Subjects/CalendarSubject';
import { formatDateToWords } from '../../../utilities/dateUtils';
import { formatRemainingTimeForMeeting } from '../../../utilities/formatRemainingTimeForMeeting';
import './RescheduleMeetingSection.css';

const RescheduleMeetingSection = () => {
    const { currentUser } = useAuth();
    const [authToken, setAuthToken] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [universalloading, setUniversalLoading] = useState<boolean>(false);
    // const [meetings, setMeetings] = useState<UpcommingMeetingDto[]>([]);
    const [allUpcomingMeetings, setAllUpcomingMeetings] = useState<UpcommingMeetingDto[]>([]);
    const [rescheduleModal, setRescheduleModal] = useState<boolean>(false);
    const [selectedMeeting, setSelectedMeeting] = useState<UpcommingMeetingDto>();
    const [selectedUsers, setSelectedUsers] = useState<TeamUser[]>([]);
    const [selectedDate, setSelectedDate] = useState<Date>();


    const [currentTime, setTime] = useState(moment());
    const navigate = useNavigate();

    const [title, setTitle] = useState<string>("Upcoming Meetings");

    const handleShowRescheduleModal = () => setRescheduleModal(true);
    const handleCloseRescheduleModal = () => setRescheduleModal(false);

    useEffect(() => {
        if (selectedUsers.length === 1 && selectedUsers[0].id !== currentUser?.uid) {
            setTitle(`${selectedUsers[0].firstName[0]}. ${selectedUsers[0].lastName}'s Meetings`);
        } else {
            setTitle("Upcoming Meetings");
        }
    }, [selectedUsers, currentUser]);

    const fetchAllUpcomingMeetings = async (userIds: string[], date: Date) => {
        setLoading(true);
        setAllUpcomingMeetings([]);
        try {
            // 0th index becous we can select only one user from header at a time
            if (!currentUser) return;
            const token = await currentUser?.getIdToken();
            date.setHours(0, 0, 0, 0);
            const meetingResult = await getUpcomingMeetingsByDate(userIds[0], token, moment(date).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'));
            if (meetingResult.success) {
                console.log('Meeting results', meetingResult.data)
                setAllUpcomingMeetings(meetingResult.data);
            }
        } catch (error) {
            console.error("Failed to load meetings:", error);
            setAllUpcomingMeetings([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let userSubscription: Subscription;
        const tokenPromise = currentUser?.getIdToken();

        if (tokenPromise) {
            tokenPromise.then(token => {
                setAuthToken(token);
                userSubscription = selectedUserForTask$.subscribe((users) => {
                    setSelectedUsers(users);
                });
            });
        }

        // update every second so pre-join countdown & auto-enable works without refresh
        const timer = setInterval(() => setTime(moment()), 1000);

        return () => {
            if (userSubscription) userSubscription.unsubscribe();
            clearInterval(timer);
        };
    }, [currentUser]);

    useEffect(() => {
        const dateSubscription = selectedDate$.subscribe(date => {
            console.log("lisson : ", date);

            setSelectedDate(date);
        });

        return () => {
            if (dateSubscription) dateSubscription.unsubscribe();
        };
    }, []);

    useEffect(() => {
        // const filtered = allUpcomingMeetings.filter(meeting =>
        //     moment(meeting.startTime).isSame(selectedDate, 'day')
        // );
        // setMeetings(filtered);

        // directly fetch from the DB
        if (!currentUser || !selectedDate) return;

        const userIds = selectedUsers.length > 0 ? selectedUsers.map(u => u.id) : [currentUser.uid];
        fetchAllUpcomingMeetings(userIds, selectedDate);
    }, [selectedDate, selectedUsers]);


    const refreshMeetings = () => {
        const userIds = selectedUsers.length > 0 ? selectedUsers.map(u => u.id) : (currentUser ? [currentUser.uid] : []);
        if (userIds.length > 0 && authToken && selectedDate) {
            fetchAllUpcomingMeetings(userIds, selectedDate);
        }
    };

    const handleClickReschedule = (item: UpcommingMeetingDto) => {
        setSelectedMeeting(item);
        handleShowRescheduleModal();
    }

    const handleClickJoin = (eventId: string, disabled: boolean) => {
        if (disabled) {
            // If user clicks while disabled, show helpful message (tooltip also present)
            toast.info("Joining opens 30 min before start.");
            return;
        }
        setUniversalLoading(true);
        GetExistingOrCretateMeetingAsync(authToken, eventId).then((res) => {
            if (res.success) {
                const states: LobbyState = {
                    calenderEventId: eventId,
                    isPublisher: res.data.isPublisher,
                    isOneToOneCall: false,
                }
                navigate(`/lobby/${res.data.roomId}`, { state: states })
            } else {
                // server should reject early joins with clear validation error
                toast.error(res.message)
            }
        }).catch((err) => {
            toast.error(err.message)
        }).finally(() => {
            setUniversalLoading(false);
        })
    }

    return (
        <>
            {universalloading && <Loader />}

            <div className="upcoming_mettings h-100">
                <div className="common_card h-100">
                    <div className="top top_bar_flx border_tittle">
                        <div className="top_bar_tittle">
                            <h2>{title}</h2>
                        </div>
                        <span>{selectedDate && formatDateToWords(selectedDate)}</span>
                    </div>
                    <div className="upcomingmeetings_card_flx">
                        {allUpcomingMeetings.length === 0 ?
                            (
                                <p className='text-center mt-5'> {loading ? 'Loading...' : 'No Meeting Found'}</p>
                            ) :
                            (<>
                                {allUpcomingMeetings.slice(0, 2).map(
                                    (meeting) => {
                                        const meetTime = moment
                                            .utc(meeting.startTime)
                                            .local();

                                        const timeStr = formatMeetingTime(meetTime.toDate());
                                        const participants = meeting.participantUsers
                                            .filter(p => p.participantId !== currentUser?.uid)
                                            .map(p => p.participantName)
                                            .join(", ");

                                        const start = moment.utc(meeting.startTime).local();
                                        const end = moment.utc(meeting.endTime).local();

                                        // pre-join window starts 30 minutes before meeting start (local time)
                                        const preJoinStart = start.clone().subtract(30, 'minutes');

                                        // use currentTime (updated every second) so UI auto-enables at T-30
                                        const isWithinPrejoinWindow = currentTime.isSameOrAfter(preJoinStart) && currentTime.isSameOrBefore(end);
                                        const isBeforePrejoin = currentTime.isBefore(preJoinStart);
                                        const isOwner = meeting.ownerUserID === currentUser?.uid;
                                        const isParticipant = meeting.participantUsers.some(p => p.participantId == currentUser?.uid) || meeting.ownerUserID == currentUser?.uid;

                                        // allow join only if invited and within [T-30 .. end]
                                        const canJoin = isParticipant && isWithinPrejoinWindow;
                                        const canReschedule = isOwner && start.isAfter(moment());

                                        // helper/tooltip message when user cannot join yet
                                        const msUntilPrejoin = preJoinStart.diff(currentTime);
                                        let tooltipMessage = "Joining opens 30 min before start.";
                                        // show a live countdown (time until pre-join) when it's reasonably near (<= 1 hour) or always if you prefer
                                        if (msUntilPrejoin > 0 && msUntilPrejoin <= (60 * 60 * 1000)) {
                                            tooltipMessage = `You can join in ${formatRemainingTimeForMeeting(msUntilPrejoin)}`;
                                        } else if (msUntilPrejoin > 0) {
                                            tooltipMessage = "Joining opens 30 min before start.";
                                        } else if (isBeforePrejoin === false && !isWithinPrejoinWindow) {
                                            tooltipMessage = "Meeting already ended.";
                                        }

                                        return (
                                            <div
                                                className="upcomingmeetings_card"
                                                key={meeting.id}
                                            >

                                                <div className="upcomingmeetings_card_tittle">
                                                    <h3>{meeting.title}<span>{timeStr}</span></h3>
                                                </div>

                                                <ul className="upcomingmeetings_card_list">
                                                    {(
                                                        <li>
                                                            <p><strong>Attendees:</strong> {meeting.ownerUserID != currentUser?.uid && `${meeting.ownerName}, `} {participants}</p>
                                                        </li>
                                                    )}
                                                    {meeting.location && (
                                                        <li>
                                                            <p><strong>Location:</strong> {meeting.location}</p>
                                                        </li>
                                                    )}
                                                    {meeting.description && (
                                                        <li className='description'>
                                                            <p><strong>Description:</strong> {meeting.description}</p>
                                                        </li>
                                                    )}
                                                </ul>
                                                {
                                                    selectedUsers.length == 0 &&
                                                    (
                                                        <div className="btn_flx justify-content-start mby_t_24">
                                                            {/* Join button is always rendered for invited users; disabled outside pre-join window */}
                                                            {isParticipant && (
                                                                <div>
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={
                                                                            (!canJoin) ? (
                                                                                <Tooltip id={`tooltip-join-${meeting.id}`}>
                                                                                    {tooltipMessage}
                                                                                </Tooltip>
                                                                            ) : <></>
                                                                        }
                                                                        trigger={['hover', 'focus', 'click']}
                                                                    >
                                                                        <span className="d-inline-block">
                                                                            <Button
                                                                                variant="primary"
                                                                                className="btn_sm"
                                                                                onClick={() => handleClickJoin(meeting.id, !canJoin)}
                                                                                disabled={!canJoin}
                                                                                style={!canJoin ? { pointerEvents: 'auto' } : {}}
                                                                            >
                                                                                <img src={joinvideoicon} alt="join" />
                                                                                Join
                                                                            </Button>
                                                                        </span>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            )}
                                                            {canReschedule && (
                                                                <div>
                                                                    <Button
                                                                        variant="secondary"
                                                                        className="btn_sm"
                                                                        onClick={() => handleClickReschedule(meeting)}
                                                                    >
                                                                        Reschedule
                                                                    </Button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                }

                                            </div>
                                        );
                                    }
                                )}
                                {allUpcomingMeetings.length > 2 && (
                                    <div className="text-center mt-3 w-100">
                                        <Button variant="link" onClick={() => navigate('/calendar')}>
                                            View More
                                        </Button>
                                    </div>
                                )}
                            </>
                            )}
                    </div>
                </div>
            </div>

            {(rescheduleModal && selectedMeeting) &&
                <RescheduleMeetingModal
                    handleCloseRescheduleModal={handleCloseRescheduleModal}
                    rescheduleModal={rescheduleModal}
                    authToken={authToken}
                    selectedMeeting={selectedMeeting}
                    refreshMeeting={refreshMeetings}
                />
            }
        </>
    )
}

export default RescheduleMeetingSection